(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["delux-header-favorites"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('delux-header-favorites')) {
    customElements.define('delux-header-favorites', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.dialog = this.querySelector('dialog');
        this.toggle = this.querySelector('.delux-favorites-toggle');
        this.product = this.querySelector('[data-product]') ? JSON.parse(this.querySelector('[data-product]').textContent) : null;
        this.toggle.addEventListener('click', () => { this.render(); this.dialog.showModal(); }, options);
        this.querySelector('[data-close]').addEventListener('click', () => { this.dialog.close(); this.toggle.focus(); }, options);
        this.dialog.addEventListener('click', event => { if (event.target === this.dialog) { const r = this.dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close(); } }, options);
        this.querySelector('.delux-save-product')?.addEventListener('click', () => {
          let items = this.read();
          const exists = items.some(item => item.handle === this.product.handle);
          items = exists ? items.filter(item => item.handle !== this.product.handle) : [...items, this.product];
          if (this.save(items)) { this.render(); this.querySelector('[data-status]').textContent = exists ? this.dataset.remove : this.dataset.saved; }
        }, options);
        window.addEventListener('storage', () => { if (this.dialog.open) this.render(); }, options);
      }
      read() {
        try { const data = JSON.parse(localStorage.getItem('delux-favorites-v1') || '[]'); return Array.isArray(data) ? data.filter(item => item && typeof item.handle === 'string' && typeof item.title === 'string' && /^\/products\/[a-z0-9-]+$/.test(item.url)).slice(0, 100) : []; } catch { return []; }
      }
      save(items) {
        try { localStorage.setItem('delux-favorites-v1', JSON.stringify(items)); return true; } catch { this.querySelector('[data-status]').textContent = this.dataset.unavailable; return false; }
      }
      render() {
        const items = this.read();
        const list = this.querySelector('.delux-favorites-list');
        list.replaceChildren();
        if (!items.length) { const empty = document.createElement('p'); empty.textContent = this.dataset.empty; list.append(empty); }
        items.forEach(item => {
          const row = document.createElement('div'); row.className = 'delux-favorites-item';
          if (typeof item.image === 'string' && /^https:\/\/cdn.shopify.com\//.test(item.image)) { const image = document.createElement('img'); image.src = item.image; image.alt = ''; image.width = 64; image.height = 64; row.append(image); }
          const link = document.createElement('a'); link.href = item.url; link.textContent = item.title; row.append(link);
          const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = '×'; remove.setAttribute('aria-label', this.dataset.remove + ': ' + item.title);
          remove.addEventListener('click', () => { if (this.save(this.read().filter(saved => saved.handle !== item.handle))) { this.render(); this.querySelector('.delux-save-product, .delux-favorites-browse').focus(); } });
          row.append(remove); list.append(row);
        });
        const save = this.querySelector('.delux-save-product');
        if (save) { const saved = items.some(item => item.handle === this.product.handle); save.textContent = saved ? this.dataset.remove : this.dataset.save; save.setAttribute('aria-pressed', String(saved)); }
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["delux-header-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('delux-nav-dropdown')) {
    customElements.define('delux-nav-dropdown', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const details = this.querySelector('details');
        const item = this.closest('li');
        const summary = this.querySelector('summary');
        const close = () => { details.open = false; };
        const open = () => {
          this.closest('nav').querySelectorAll('delux-nav-dropdown details[open]').forEach(other => { if (other !== details) other.open = false; });
          details.open = true;
        };
        item.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse' && matchMedia('(hover: hover)').matches) { this.hoverOpened = true; open(); } }, options);
        item.addEventListener('pointerleave', () => { if (!item.contains(document.activeElement)) close(); }, options);
        summary.addEventListener('click', event => { event.preventDefault(); if (this.hoverOpened) { this.hoverOpened = false; open(); } else if (details.open) close(); else open(); }, options);
        item.addEventListener('focusout', event => { if (!item.contains(event.relatedTarget)) close(); }, options);
        item.addEventListener('keydown', event => {
          if (event.key === 'Escape') { close(); summary.focus(); event.preventDefault(); }
          if (event.key === 'ArrowDown' && event.target === summary) { open(); this.querySelector('.delux-navigation__child').focus(); event.preventDefault(); }
        }, options);
        document.addEventListener('pointerdown', event => { if (!item.contains(event.target)) close(); }, options);
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
